import { datadogRum } from '@datadog/browser-rum'
import { reactPlugin } from '@datadog/browser-rum-react';
import { datadogLogs } from '@datadog/browser-logs'

export function initDatadog() {
  const applicationId = process.env.REACT_APP_DATADOG_APPLICATION_ID
  const clientToken = process.env.REACT_APP_DATADOG_CLIENT_TOKEN
  const site = process.env.REACT_APP_DATADOG_SITE
  const env = process.env.REACT_APP_DATADOG_ENV
  const service = process.env.REACT_APP_DATADOG_SERVICE
  const version = process.env.REACT_APP_DATADOG_VERSION

  if (!applicationId || !clientToken) return

  datadogRum.init({
    applicationId,
    clientToken,
    site,
    service,
    env,
    version,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    plugins: [reactPlugin({ router: false })],
  })

  datadogLogs.init({
    clientToken,
    site,
    service,
    env,
    version,
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
  })
}

export { datadogRum, datadogLogs }
